import BatterTableDataView from "@/components/BatterTableDataView";
import ButtonDialog from "@/components/ButtonDialog";
export default {
  name: "UserManageView",
  components: {
    ButtonDialog,
    BatterTableDataView
  },
  data() {
    return {
      groups: [],
      groupId: 0,
      search: null
    };
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};